export class AptTrade {
  aptDong: string | null = null;
  aptNm = "";
  aptSeq = "";
  bonbun = "";
  bubun = "";
  buildYear = 0;
  buyerGbn = "";
  cdealDay: string | null = null;
  cdealType: string | null = null;
  createDatetime = "";
  dealAmount = 0;
  dealMonth = 0;
  dealYear = 0;
  dealDay: number | null = null;
  dealingGbn = "";
  estateAgentSggNm = "";
  excluUseAr = 0;
  floor = 0;
  jibun = "";
  landCd = "";
  landLeaseholdGbn = "";
  rgstDate: string | null = null;
  roadNm = "";
  roadNmBonbun = "";
  roadNmBubun = "";
  roadNmCd = "";
  roadNmSeq = "";
  roadNmSggCd = "";
  roadNmbCd = "";
  sggCd = "";
  slerGbn = "";
  umdCd = "";
  umdNm = "";
  updateDatetime = "";

  public init(obj: any) {
    this.aptDong = obj.aptDong ?? null;
    this.aptNm = obj.aptNm ?? "";
    this.aptSeq = obj.aptSeq ?? "";
    this.bonbun = obj.bonbun ?? "";
    this.bubun = obj.bubun ?? "";
    this.buildYear = obj.buildYear ?? 0;
    this.buyerGbn = obj.buyerGbn ?? "";
    this.cdealDay = obj.cdealDay ?? null;
    this.cdealType = obj.cdealType ?? null;
    this.createDatetime = obj.createDatetime ?? "";
    this.dealAmount = obj.dealAmount ?? 0;
    this.dealMonth = obj.dealMonth ?? 0;
    this.dealYear = obj.dealYear ?? 0;
    this.dealDay = obj.dealDay ?? null;
    this.dealingGbn = obj.dealingGbn ?? "";
    this.estateAgentSggNm = obj.estateAgentSggNm ?? "";
    this.excluUseAr = obj.excluUseAr ?? 0;
    this.floor = obj.floor ?? 0;
    this.jibun = obj.jibun ?? "";
    this.landCd = obj.landCd ?? "";
    this.landLeaseholdGbn = obj.landLeaseholdGbn ?? "";
    this.rgstDate = obj.rgstDate ?? null;
    this.roadNm = obj.roadNm ?? "";
    this.roadNmBonbun = obj.roadNmBonbun ?? "";
    this.roadNmBubun = obj.roadNmBubun ?? "";
    this.roadNmCd = obj.roadNmCd ?? "";
    this.roadNmSeq = obj.roadNmSeq ?? "";
    this.roadNmSggCd = obj.roadNmSggCd ?? "";
    this.roadNmbCd = obj.roadNmbCd ?? "";
    this.sggCd = obj.sggCd ?? "";
    this.slerGbn = obj.slerGbn ?? "";
    this.umdCd = obj.umdCd ?? "";
    this.umdNm = obj.umdNm ?? "";
    this.updateDatetime = obj.updateDatetime ?? "";
  }

  public bind(res: any) {
    const obj = res.data ?? {};
    this.aptDong = obj.aptDong ?? null;
    this.aptNm = obj.aptNm ?? "";
    this.aptSeq = obj.aptSeq ?? "";
    this.bonbun = obj.bonbun ?? "";
    this.bubun = obj.bubun ?? "";
    this.buildYear = obj.buildYear ?? 0;
    this.buyerGbn = obj.buyerGbn ?? "";
    this.cdealDay = obj.cdealDay ?? null;
    this.cdealType = obj.cdealType ?? null;
    this.createDatetime = obj.createDatetime ?? "";
    this.dealAmount = obj.dealAmount ?? 0;
    this.dealMonth = obj.dealMonth ?? 0;
    this.dealYear = obj.dealYear ?? 0;
    this.dealDay = obj.dealDay ?? null;
    this.dealingGbn = obj.dealingGbn ?? "";
    this.estateAgentSggNm = obj.estateAgentSggNm ?? "";
    this.excluUseAr = obj.excluUseAr ?? 0;
    this.floor = obj.floor ?? 0;
    this.jibun = obj.jibun ?? "";
    this.landCd = obj.landCd ?? "";
    this.landLeaseholdGbn = obj.landLeaseholdGbn ?? "";
    this.rgstDate = obj.rgstDate ?? null;
    this.roadNm = obj.roadNm ?? "";
    this.roadNmBonbun = obj.roadNmBonbun ?? "";
    this.roadNmBubun = obj.roadNmBubun ?? "";
    this.roadNmCd = obj.roadNmCd ?? "";
    this.roadNmSeq = obj.roadNmSeq ?? "";
    this.roadNmSggCd = obj.roadNmSggCd ?? "";
    this.roadNmbCd = obj.roadNmbCd ?? "";
    this.sggCd = obj.sggCd ?? "";
    this.slerGbn = obj.slerGbn ?? "";
    this.umdCd = obj.umdCd ?? "";
    this.umdNm = obj.umdNm ?? "";
    this.updateDatetime = obj.updateDatetime ?? "";
  }
}

export class SeoulTradeStat {
  year = 0;
  month = 0;
  day = 0;
  totalCount = 0;
  totalAvgAmount = 0;
  cancelCount = 0;
  cancelAvgAmount = 0;
}

export class SeoulTradeStatRequest {
  sggCd = "";
  umdCd = "";
  aptNm = "";
  minExcluUseAr = "";
  maxExcluUseAr = "";
  startYmd = "20250101";
  endYmd = "20301201";
  groupBy: "YEAR" | "MONTH" | "DAY" = "YEAR";

  constructor(
    startYmd?: string,
    endYmd?: string,
    groupBy?: "YEAR" | "MONTH" | "DAY"
  ) {
    if (startYmd) this.startYmd = startYmd;
    if (endYmd) this.endYmd = endYmd;
    if (groupBy) this.groupBy = groupBy;
  }
  // constructor() {
  //   //
  // }

  bind(obj: {
    sggCd?: any;
    umdCd?: any;
    aptNm?: any;
    minExcluUseAr?: any;
    maxExcluUseAr?: any;
    startYmd?: any;
    endYmd?: any;
    groupBy?: any;
  }): this {
    if (obj.sggCd !== undefined) this.sggCd = String(obj.sggCd);
    if (obj.umdCd !== undefined) this.umdCd = String(obj.umdCd);
    if (obj.aptNm !== undefined) this.aptNm = String(obj.aptNm);
    if (obj.minExcluUseAr !== undefined)
      this.minExcluUseAr = String(obj.minExcluUseAr);
    if (obj.maxExcluUseAr !== undefined)
      this.maxExcluUseAr = String(obj.maxExcluUseAr);
    if (obj.startYmd !== undefined) this.startYmd = String(obj.startYmd);
    if (obj.endYmd !== undefined) this.endYmd = String(obj.endYmd);
    if (obj.groupBy !== undefined) this.groupBy = obj.groupBy;

    return this;
  }
}

export class SggTradeDiffResponse {
  sggCd = "";
  sggNm = "";
  yesterdayCount = 0;
  dayBeforeCount = 0;
  diff = 0;

  constructor(
    sggCd: string,
    sggNm: string,
    yesterdayCount: number,
    dayBeforeCount: number,
    diff: number
  ) {
    this.sggCd = sggCd;
    this.sggNm = sggNm;
    this.yesterdayCount = yesterdayCount;
    this.dayBeforeCount = dayBeforeCount;
    this.diff = diff;
  }
}

export class AptFavorite {
  id = 0;
  userId = 0;
  sggCd = "";
  umdCd = "";
  aptNm = "";
}

export class AptTradeDailyStatsResponse {
  day = 0;
  tradeCount = 0;

  constructor(day: number, tradeCount: number) {
    this.day = day;
    this.tradeCount = tradeCount;
  }
}
